import React from 'react'
import "./Experience.css";
const Experience = () => {
  return (
   <section className="experienceWrapper">
    <h1>Professional Experience:</h1>
    <div className="exprerienceBlock">
        <span className='expHeading'>Full Stack Web/App Developer: </span>  <br />
        <span className='expDesc'> At Fiction Developers Pvt. Limited (Nov 2024 - Present) </span>
    </div>
    <div className="exprerienceBlock">
        <span className='expHeading'>MERN Stack Developer: </span> <br />
        <span className='expDesc'> At SSL Solutions Pvt. Limited (Nov 2023 - May 2024) </span>
    </div>
    <div className="exprerienceBlock">
        <span className='expHeading'>Full Stack FreeLancer:</span> <br />
        <span className='expDesc'>{" "}Since April/2022 (Till Present)</span>
    </div>
    
   </section>
  )
}

export default Experience